import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EditionsService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.url + 'ediciones';

  findAll(params: HttpParams) {
    return this.http.get<BackendResponse>(this.url, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }
}
